import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { ecrEntityContentExtension, amazonEcrApi } from './extensions';
import { digestRouteRef, rootRouteRef } from '../routes';
/**
 * @alpha
 */
export const amazonEcrPlugin = createFrontendPlugin({
    pluginId: 'amazon-ecr',
    routes: {
        index: rootRouteRef,
        digest: digestRouteRef
    },
    extensions: [ecrEntityContentExtension, amazonEcrApi],
});